<template>
  <span>
    <h3 class="ma-0 pa-0">Patient Information</h3>
    <v-row>
      <v-col cols="12" md="4" lg="4" xl="4">
        <!-- Full Name -->
        <v-text-field v-model="form.name" placeholder=" " class="primary-label">
          <template v-slot:label>
            <span class="font-weight-bold">Full Name</span>
          </template>
        </v-text-field>
        <!-- Height -->
        <v-row>
          <v-col cols="12" md="6" lg="6" xl="6" class="py-0">
            <v-text-field
              v-model="form.height.feet"
              placeholder=" "
              class="primary-label"
              suffix="ft"
              type="number"
            >
              <template v-slot:label>
                <span class="font-weight-bold">Height (feet)</span>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" md="6" lg="6" xl="6" class="py-0">
            <v-text-field
              v-model="form.height.inch"
              placeholder=" "
              class="primary-label"
              suffix="in"
              type="number"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <!-- Company -->
        <v-text-field
          v-model="form.company"
          placeholder=" "
          class="primary-label"
        >
          <template v-slot:label>
            <span class="font-weight-bold">Company name</span>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12" md="4" lg="4" xl="4">
        <!-- Age -->
        <v-text-field v-model="form.age" readonly placeholder=" " class="primary-label">
          <template v-slot:label>
            <span class="font-weight-bold">Age</span>
          </template>
        </v-text-field>
        <!-- Weight -->
        <v-text-field
          v-model="form.weight"
          placeholder=" "
          class="primary-label"
        >
          <template v-slot:label>
            <span class="font-weight-bold">Weight (kg)</span>
          </template>
        </v-text-field>
        <!-- Provider -->
        <v-text-field
          v-model="form.provider"
          placeholder=" "
          class="primary-label"
        >
          <template v-slot:label>
            <span class="font-weight-bold">Provider name</span>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12" md="4" lg="4" xl="4">
        <!-- Birthdate -->
        <v-dialog
          ref="birthdateModal"
          v-model="birthdateDialog"
          :return-value.sync="form.birthdate"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="form.birthdate"
              placeholder="MM/DD/YYYY"
              append-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            >
              <template v-slot:label>
                <span class="font-weight-bold primary--text">Birth date</span>
              </template>
            </v-text-field>
          </template>
          <v-date-picker v-model="form.birthdate" scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="birthdateDialog = false">
              Cancel
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.birthdateModal.save(form.birthdate)"
            >
              OK
            </v-btn>
          </v-date-picker>
        </v-dialog>
        <!-- BMI -->
        <v-text-field
          v-model="form.bmi"
          placeholder="Automatically shown when inputting ht and wt"
          class="primary-label"
          :messages="form.bmiStatus"
          readonly
        >
          <template v-slot:label>
            <span class="font-weight-bold">BMI</span>
          </template>
        </v-text-field>
      </v-col>
    </v-row>
  </span>
</template>

<script>
import moment from "moment";

export default {
  props: {
    form: {
      type: Object,
      default: () => {
        return {
          height: {
            feet: 0,
            inch: 0,
          },
          weight: 0
        };
      },
    },
  },
  data: () => ({
    birthdateDialog: false
  }),
  watch: {
    form: {
      handler: function(value) {
        let haveHeightWeight = value.height && value.weight;

        if (haveHeightWeight) {
          this.computeBodyMassIndex();
        }
      },
      deep: true
    },
    "form.birthdate": function(value) {
      if (value) {
        let years = moment().diff(value, "years");

        this.form.age = years || 0;
      }
    }
  },
  methods: {
    computeBodyMassIndex() {
      let feetToMeter = 0.3048;
      let inchToMeter = 0.0254;

      /**
       * add + before the value to convert to number
       */

      let height = (+this.form.height.feet * feetToMeter) + (+this.form.height.inch * inchToMeter);

      let bodyMassIndex = (+this.form.weight / (Math.pow(height, 2))).toFixed(2);

      this.form.bmi = bodyMassIndex;

      if (!isNaN(bodyMassIndex)) {
        if (bodyMassIndex > 40) {
          this.form.bmiStatus = "Obesity Class III";
          return;
        }

        if (bodyMassIndex > 35 && bodyMassIndex <= 39.9) {
          this.form.bmiStatus = "Obesity Class II";
          return;
        }

        if (bodyMassIndex > 30 && bodyMassIndex <= 34.9) {
          this.form.bmiStatus = "Obesity Class I";
          return;
        }

        if (bodyMassIndex > 25 && bodyMassIndex <= 29.9) {
          this.form.bmiStatus = "Overweight";
          return;
        }

        if (bodyMassIndex > 18.5 && bodyMassIndex <= 24.9) {
          this.form.bmiStatus = "Normal";
          return;
        }

        this.form.bmiStatus = "Underweight";
        return;
      }

      this.form.bmi = null;
      this.form.bmiStatus = null;
      return;
    },
  },
};
</script>